export default "__VITE_ASSET__DY9rO0_f__"